const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Report Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('editReport', ['Application', 'Authorization', 'CustomReportQueryService', 'ReportsData', '$scope', '$translate', function (Application, Authorization, CustomReportQueryService, ReportsData, $scope, $translate) {
  var self = this;
  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  const routeParameters = Application.navigation.getRouteParameters();
  self.newReport = routeParameters.id === 'new' || !routeParameters.id;
  self.translations = {};
  self.editSaved = true;
  self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
  self.denied = false;
  self.activeTab = 'details';
  self.types =  ReportsData.reportTypes;
  self.fields = ReportsData.reportFields;

  const filterTypeToSearchType = {
    Article: 'articles',
    Assignment: 'assignments',
    Media: 'media',
    ImportedContent: 'imported_content',
    ScormContent: 'scorm',
    Track: 'tracks',
    Workshop: 'workshops',
    User: "user",
    location: "location",
    department: "department",
    team: "team",
    org_level: "org_level",
    grade: "grade",
    Group: "group",
    Assessment: 'assessments'
  }
  const searchTypesToModel = {
    articles: 'Article',
    assignments: 'Assignment',
    files: 'Media',
    imported_content: 'ImportedContent',
    media: 'Media',
    scorm: 'ScormContent',
    tracks: 'Track',
    videos: 'Media',
    workshops: 'Workshop',
    user: 'User',
    location: 'Category',
    department: 'Category',
    team: 'Category',
    org_level: 'Category',
    grade: 'Category',
    group: 'Group',
    assessments: 'Assessment'
  }

  self.filterSuspendedUsersTypes = [
    'user-engagement',
    'assignment-summary',
    'manager-summary',
    'track-status',
    'workshop-status',
    'scorm-status',
    'assessment-status'
  ]

  self.models = {
    name: '',
    baseType: '',
    fields: [],
    userFilters: new Set(),
    contentFilters: new Set(),
    options: {
      includeSuspendedUsers: false,
    },
    format: 'CSV',
    helptextType: '',
    helptextSubtype: '',
    helptextFields: ''
  };

  self.navigationDirectory = {
    'details': {
      next: 'filters',
      previous: null,
      required: ['name', 'baseType']
    },
    'filters': {
      next: 'fields',
      previous: 'details',
      required: null
    },
    'fields': {
      next: 'preview',
      previous: 'filters',
      required: ['fields']
    },
    'preview': {
      next: null,
      previous: 'fields',
      required: null
    },
    requiredKeyMap: {
      name: 'global.forms.labels_name',
      baseType: 'global.forms.labels_type',
      fields: 'global.forms.labels_fields'
    }
  }

  const locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      self.denied = true;
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();
    event.preventDefault();
    self.showDeparture = true;
  });
  self.onLocationChange = function() {
    locationChange();
  };

  self.nextSection = function(tab) {
    const current = tab ? self.navigationDirectory[tab].previous : self.activeTab;
    const next = self.navigationDirectory[current].next;
    var missing = '';
    var allow = true;

    if (next === 'preview'){self.tableOverflowChecking();}

    const findIssues = function(check) {
      const current = self.navigationDirectory[check];
      if (current.required) {
        current.required.forEach(function(requiredField) {
          const fieldValue = self.models[requiredField];
          if (!fieldValue || (Array.isArray(fieldValue) && fieldValue.length === 0)) {
            const addition = self.navigationDirectory.requiredKeyMap[requiredField] ? self.translations[self.navigationDirectory.requiredKeyMap[requiredField]] : requiredField;
            allow = false;
            missing = missing + ' ' + addition + ',';
          }
        });
      }
      if (current.previous) {
        findIssues(current.previous);
      }
    };

    findIssues(current);

    if (allow && next) {
      self.activeTab = next;
      Application.scrollTop();
    }
    if (missing) {
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
    }
  };

  self.goBack = function() {
    if (!self.denied || !self.backLocation) {
      Application.navigation.back();
      self.denied = true;
      return;
    }
    self.denied = true;
    var location = self.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.specialClose = function(specialCloseLast) {
    self.activeTab = specialCloseLast ? specialCloseLast : 'details';
  };
  self.specialCloseLast = 'details';

  self.tableOverflowChecking = function(){
    var table = document.querySelector('.ui.table');
    var overwrap = document.querySelector('.js-overwrap');
    if(table.clientWidth > overwrap.clientWidth){
      overwrap.style.overflowX = 'scroll';
    } else if(table.clientWidth === overwrap.clientWidth){
      overwrap.style.overflowX = 'auto';
    }
  }

  self.toggleField = function(i) {
    const fieldsSet = new Set(self.models.fields);
    if (fieldsSet.has(i)) {
      fieldsSet.delete(i);
    } else {
      fieldsSet.add(i);
    }
    // maintain field order from reportFieldsByKey when toggling
    self.models.fields = Object.keys(ReportsData.reportTypes[self.models.baseType].reportFieldsByKey).filter(function(field) {
      return fieldsSet.has(field)
    });
  };

  self.onTypeChange = function() {
    self.resetModels();
    self.selectAllFields();
  };

  self.selectAllFields = function() {
    self.clearFields();
    ReportsData.reportTypes[self.models.baseType].defaultFields.forEach(function(field) {
      self.models.fields.push(field.key);
    });
  }

  self.clearFields = function() {
    self.models.fields = [];
  }

  self.resetModels = function() {
    self.clearFields();
    self.models.userFilters = new Set();
    self.models.contentFilters =  new Set();
  };

  function getReportJson() {
    const filtersMap = {};
    const filterJson = function (filter) {
      const filterType = searchTypesToModel[filter.type];
      if (!(filterType in filtersMap)) {
        filtersMap[filterType] = [];
      }
      filtersMap[filterType].push(filter._id);
    };
    self.models.userFilters.forEach(filterJson);
    self.models.contentFilters.forEach(filterJson);

    const filters = [];
    Object.keys(filtersMap).forEach(function (filterType) {
      filters.push({value: filtersMap[filterType], value_type: filterType})
    });

     // include manual_completed_by if any manual completed fields are present
     const manualCompletedOptions = [
      'manual_completed_by_first_name',
      'manual_completed_by_last_name',
      'manual_completed_by_email',
      'manual_completed_by_image',
      'manual_completed_by_userid',
      'manual_completed_by_job_title',
      'manual_completed_by_is_manager'
    ]
    for (const option of manualCompletedOptions) {
      if (self.models.fields.indexOf(option) !== -1) {
        if (self.models.fields.indexOf('manual_completed_by') === -1) {
          self.models.fields.push('manual_completed_by');
        }
        break;
      }
    }

    return {
      name: self.models.name,
      report_type: self.models.baseType,
      report_fields: self.models.fields,
      report_filters: filters,
      report_options: self.models.options
    };
  }

  self.createReport = function(){
    CustomReportQueryService.create({}, getReportJson()).$promise
      .then(function() {
        self.editSaved = true;
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.report_created'], duration: 7});
        Application.navigation.goTo('/overview/reports');
        Application.plantrack.track('report_created');
      });
  };

  self.updateReport = function(){
    CustomReportQueryService.update({subresource: routeParameters.id}, getReportJson()).$promise
      .then(function() {
        self.editSaved = true;
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.report_saved'], duration: 7});
        Application.navigation.goTo('/overview/reports');
        Application.plantrack.track('report_updated');
      });
  };

  self.onUserFilterAdd = function(item) {
    if (!('type' in item)) return;
    self.models.userFilters.add(item);
  };

  self.onUserFilterRemove = function(item) {
    self.models.userFilters.delete(item);
  };

  self.onAllUserFiltersRemoved = function() {
    self.models.userFilters = new Set();
  };

  self.onContentFilterAdd = function(item) {
    if (!('type' in item)) return;
    self.models.contentFilters.add(item);
  };

  self.onContentFilterRemove = function(item) {
    self.models.contentFilters.delete(item);
  };

  self.onAllContentFiltersRemoved = function() {
    self.models.contentFilters = new Set();
  };

  self.startEditWatch = function() {
    $scope.$watch('report.models', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);
  };

  self.init = function() {
    if (!self.newReport) {
      const userFilters = new Set();
      const contentFilters = new Set();
      CustomReportQueryService.get({subresource: routeParameters.id}).$promise.then(function (data) {
        data.report_filters.forEach(function(reportFilter) {
          const searchType = filterTypeToSearchType[reportFilter.value_sub_type || reportFilter.value_type];
          reportFilter.value.forEach(function(reportFilterValue) {
            const filter = {
              _id: reportFilterValue._id,
              name: reportFilterValue.label,
              type: searchType
            };
            if (
              searchType === filterTypeToSearchType.User ||
              searchType === filterTypeToSearchType.location ||
              searchType === filterTypeToSearchType.department ||
              searchType === filterTypeToSearchType.team ||
              searchType === filterTypeToSearchType.org_level ||
              searchType === filterTypeToSearchType.grade ||
              searchType === filterTypeToSearchType.Group
            ) {
              userFilters.add(filter);
            } else {
              contentFilters.add(filter);
            }
          });
        });

        //maintain field order from reportFieldsByKey when loading report
        const reportFieldsSet = new Set(data.report_fields);
        const reportFields = Object.keys(self.types[data.report_type].reportFieldsByKey).filter(function(field) {
          return reportFieldsSet.has(field)
        });

        Object.keys(data.report_options).forEach(option => {
          self.models.options[option] = data.report_options[option];
        })

        self.models.name = data.name;
        self.models.baseType = data.report_type;
        self.models.fields = reportFields;
        self.models.userFilters = userFilters;
        self.models.contentFilters = contentFilters;
      });
    }
    self.startEditWatch();
  };
  $translate([
    'edit.general.notification_fieldsMissing',
    'edit.general.notification_confirmLeave',
    'global.forms.labels_name',
    'global.forms.labels_type',
    'global.forms.labels_fields',
    'modules.notifications.report_created',
    'modules.notifications.report_saved',
    'reportsManager.search_placeholder'
  ]).then(function(translations) {
    self.translations = translations;
    self.init();
  });

}]);